<script setup lang="ts">
import AppButton2 from '../AppButton2.vue'

const props = defineProps<{
  open?: boolean
}>()

const emit = defineEmits(['hide'])
</script>

<template>
  <div
    class=" row-start-1 row-end-1 col-start-1 col-end-1 px-2xl xl:py-15 flex flex-col gap-12 transform-gpu duration-400 ease-in-out z-80 overflow-y-auto"
    :class="props.open ? 'translate-y-0 bg-background-1 max-h-[calc(100svh-72px)] xl:max-h-none pointer-events-auto' : '-translate-y-full pointer-events-none'"
  >
    <NuxtLink
      to="/o-nas/"
      class="py-2.5 px-3 border-b border-Tertiary w-fit"
      @click="emit('hide')"
    >
      <span class="text-H4 font-semibold! text-Tekst">O nas</span>
    </NuxtLink>
    <div
      class="flex flex-col xl:flex-row xl:gap-20 justify-between"
      @click="emit('hide')"
    >
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/o-nas/#jak-powstala-ostoja"
          class="w-full"
        >
          <span class="text-Menu">Jak powstała Ostoja</span>
        </AppButton2>
        <AppButton2
          href="/o-nas/#sklad"
          class="w-full"
        >
          <span class="text-Menu">Co wchodzi w skład Ostoi Seniora</span>
        </AppButton2>
        <AppButton2
          href="/o-nas/#o-inwestycji"
          class="w-full"
        >
          <span class="text-Menu">O inwestycji</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/o-nas/#zaufanie"
          class="w-full"
        >
          <span class="text-Menu">Zezwolenia i certyfikaty</span>
        </AppButton2>
        <AppButton2
          href="/o-nas/#media-o-nas"
          class="w-full"
        >
          <span class="text-Menu">Media o nas</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/o-nas/#kontakt"
          class="w-full"
        >
          <span class="text-Menu">Kontakt</span>
        </AppButton2>
      </div>
    </div>
  </div>
</template>
